import React, {Component} from 'react'
import NavBar from '../navbar'

const styles = {
  content: {
    position: `absolute`,
    top: `42px`,
    backgroundColor: `#ddd`,
    color: `black`,
    width: `100%`,
  },
}
class App extends Component {
  render() {
    return (
    <div>
      <NavBar />
      <div style={styles.content}>{this.props.children}</div>
    </div>
  )}
}

App.propTypes = {
  children: React.PropTypes.oneOfType([
      React.PropTypes.arrayOf(React.PropTypes.node),
      React.PropTypes.node,
  ]),
}

export default App



// WEBPACK FOOTER //
// ./src/app/index.js